import { gql } from "@apollo/client";

const GET_PENDING_WHATSAPP_CALLS = gql`
  query GetPendingWhatsAppCalls {
    getPendingWhatsAppCalls {
      id
      callId
      inboxId
      agentId
      from
      to
      phoneNumberId
      customerName
      status
      sdpOffer
      sdpAnswer
      direction
      startTime
      endTime
      updatedAt
      duration
    }
  }
`;

export default GET_PENDING_WHATSAPP_CALLS;
